import { render, staticRenderFns } from "./VLeaseDeviationsModal.vue?vue&type=template&id=13942785&"
import script from "./VLeaseDeviationsModal.vue?vue&type=script&lang=js&"
export * from "./VLeaseDeviationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports